import isNumber from 'lodash.isnumber';
import flatten from 'lodash.flatten';

import { SCREEN_SIZES } from './constants';

export function generateSimpleClass(variantObj) {
  const [name, value] = Object.entries(variantObj)[0];
  return `${name}-${value}`;
}

export function generateColClass(colProps) {
  if (!colProps) {
    return '';
  }

  function genClass(elem) {
    const colValue = colProps[elem];
    if (!colValue) {
      return '';
    }
    const numberOfCols = isNumber(colValue) ? `-${colValue}` : '';
    return colValue ? `col-${elem}${numberOfCols}` : '';
  }

  return SCREEN_SIZES.map(genClass)
    .filter(val => val)
    .join(' ');
}

export function generateReorderClass(props) {
  if (!props) {
    return '';
  }

  const entries = Object.entries(props).filter(([, val]) => val);

  const arrayOfReorderClasses = entries.map(
    ([reorderVariant, listOfColSizes]) => {
      const classes = listOfColSizes.map(col =>
        generateSimpleClass({ [reorderVariant]: col })
      );

      return classes;
    }
  );

  return flatten(arrayOfReorderClasses).join(' ');
}
